module.exports = __webpack_public_path__ + "assets/img/到着作业中.c943a743.svg";